import CarrierVehicleDeleteModal from './styled';

export default CarrierVehicleDeleteModal;
